import {Injectable} from '@angular/core';
import {AuthHttpService} from "./auth-http.service";
import {AppResponse} from "./app-response.model";
import {Banner} from "../model/banner/banner";
import {Observable} from "rxjs";
import {of} from "rxjs/index";
import {optimistic} from "./common-http.service";

@Injectable({
  providedIn: 'root'
})
export class BannerApiService {

  loaded: boolean = false;
  banner: Banner;

  constructor(private authHttp: AuthHttpService) {
    this.downloadBanner().subscribe((banner) => {
      this.banner = banner;
      this.loaded = true;
    });
  }

  downloadBanner(): Observable<Banner> {
    return this.authHttp.get<any>("/banner/get").pipe(optimistic);
  }

  getBanner(): Observable<Banner> {
    if (this.loaded) {
      return of(this.banner);
    }
    else {
      return this.downloadBanner();
    }
  }

  setText(text: string): Observable<AppResponse<void>> {
    return this.authHttp.post<void>("/banner/set/text", text);
  }

  setImage(imageData: FormData): Observable<AppResponse<void>> {
    return this.authHttp.post<void>("/banner/set/image", imageData, { observe: 'response' });
  }

  setUrl(url: string | null): Observable<any> {
    const body = url ?? '';
    return this.authHttp.post<any>("/banner/set/url", body, {
      headers: { 'Content-Type': 'text/plain' }
    }).pipe(optimistic);
  }
}
